/* TODO - This legacy component needs to be remove when we retire UPLOAD_MIGRATION_TO_GRAPHQL_4090 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { BehaviorSubject } from 'rxjs';
import {
  AssignableField,
  HeaderColumn,
  HeaderColumnsRow,
} from '../../upload-requests-api/upload-requests-api.service';

@Component({
    selector: 'app-columns-tab-content',
    templateUrl: './columns-tab-content.component.html',
    styleUrls: ['./columns-tab-content.component.scss'],
    standalone: false
})
export class ColumnsTabContentComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() mappedColumnFields!: Map<string, string>;
  @Input() assignableFields!: Array<AssignableField>;
  @Input() headerColumnRows!: Array<HeaderColumnsRow>;
  @Input() selectedHeaderRowIndex = 0;
  @Input() isColumnsLoading!: BehaviorSubject<boolean>;
  @Output() updateMappedColumnFields = new EventEmitter();
  @Output() updateSelectedHeaderRowIndex = new EventEmitter();
  selectedColumns: Array<HeaderColumn> = [];
  dragContainerName = 'drag';
  isLoading = false;

  constructor(private dragulaService: DragulaService) {}

  ngOnInit(): void {
    const group = this.dragulaService.createGroup(this.dragContainerName, {
      revertOnSpill: true,
      removeOnSpill: false,
    });

    this.dragulaService
      .drop(this.dragContainerName)
      .subscribe(({ target, el, source }) => {
        group.drake.cancel();
        const targetAssignableField = target.getAttribute(
          'data-assignable-field',
        );

        const columnHeaderFromList =
          el.getAttribute('data-column-header') || '';

        const assignableFieldWithColumnHeader = source.getAttribute(
          'data-assignable-field',
        );

        if (targetAssignableField && columnHeaderFromList) {
          /**
           * When dragging from column list to assignable fields.
           */
          this.mappedColumnFields.set(
            targetAssignableField,
            columnHeaderFromList,
          );
        } else if (targetAssignableField && assignableFieldWithColumnHeader) {
          /**
           * When dragging from one assignable field to another.
           */
          this.mappedColumnFields.set(
            targetAssignableField,
            this.mappedColumnFields.get(assignableFieldWithColumnHeader) || '',
          );
          this.mappedColumnFields.set(assignableFieldWithColumnHeader, '');
        } else if (!targetAssignableField && assignableFieldWithColumnHeader) {
          /**
           * When dragging an assignable field back to the column list.
           */
          this.mappedColumnFields.set(assignableFieldWithColumnHeader, '');
        }

        this.updateMappedColumnFields.emit(this.mappedColumnFields);
      });

    this.isColumnsLoading.subscribe((res) => {
      this.isLoading = res;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerColumnRows']?.currentValue) {
      this.selectedColumns = [];
    }
  }

  ngOnDestroy() {
    this.dragulaService.destroy(this.dragContainerName);
  }

  setSelectedHeaderRowIndex(el: EventTarget | null) {
    const element = el as HTMLSelectElement;
    this.selectedHeaderRowIndex = element.selectedIndex - 1;
    this.updateSelectedHeaderRowIndex.emit(this.selectedHeaderRowIndex);
  }

  isMappedColumn(columnHeader: string) {
    let showColumn = true;

    if (this.mappedColumnFields) {
      const values = this.mappedColumnFields.values();

      // TODO: optimize. This runs at every digest and could hurt performance.
      // Might be more efficient to simply maintain an array of values stored as a component property.
      for (const value of values) {
        if (value === columnHeader) {
          showColumn = false;
          break;
        }
      }
    }

    return showColumn;
  }
}
